
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","fill-rule":"evenodd","d":"M8 13.43a1.143 1.143 0 110-2.286 1.143 1.143 0 010 2.286zm1.048-4.467a.286.286 0 00-.19.27v.196a.857.857 0 11-1.715 0V8.286c0-.474.384-.857.857-.857A1.429 1.429 0 106.571 6a.857.857 0 01-1.714 0 3.143 3.143 0 114.191 2.963z"}})])
          )
        }
      }
    